import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

// Vue-router 报NavigationDuplicated的可能解决方案
const originalPush = Router.prototype.push;
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err)
};

Vue.use(Router);

const routes = [
  {
    path:'*',
    redirect: {name: 'Home'},
  },
  {
    path: '/',
    redirect: {name: 'Home'},
    // redirect: {name: 'Integrated'},
    // redirect: {name: 'Appointment-user-info'},
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/index'),
    meta: {title: '资阳市博物馆', tree: -10, keepAlive: false},
  },
  {
    path: '/appointment',
    name: 'Appointment',
    component: () => import('@/views/mobile/appointment'),
    meta: {title: '我要预约', tree: -1, keepAlive: false},
  },
  {
    path: '/appointment-step-2',
    name: 'Appointment-step-2',
    component: () => import('@/views/mobile/appointment-step-2.vue'),
    meta: {title: '', tree: 2, keepAlive: false},
  },
  {
    path: '/appointment-success',
    name: 'Appointment-success',
    component: () => import('@/views/mobile/appointment-success.vue'),
    meta: {title: '', tree: 2, keepAlive: false},
  },
  {
    path: '/appointment-user-info',
    name: 'Appointment-user-info',
    component: () => import('@/views/mobile/appointment-user-info.vue'),
    meta: {title: '', tree: 3, keepAlive: false},
  },
  {
    path: '/record-query',
    name: 'record-query',
    component: () => import('@/views/mobile/record-query.vue'),
    meta: {title: '', tree: 1, keepAlive: false},
  },
  {
    path: '/record-lists',
    name: 'record-lists',
    component: () => import('@/views/mobile/record-lists.vue'),
    meta: {title: '', tree: 2, keepAlive: false},
  },
  {
    path: '/record-details/:id',
    name: 'record-details',
    component: () => import('@/views/mobile/record-details.vue'),
    meta: {title: '', tree: 3, keepAlive: false},
  },
  {
    path: '/team',
    name: 'teamAppointment',
    component: () => import('@/views/mobile/team-appointment.vue'),
    meta: {title: '', tree: 2, keepAlive: false},
  },
  {
    path: '/introduce',
    name: 'Introduce',
    component: () => import('@/views/mobile/introduce.vue'),
    meta: {title: '预约须知', tree: -2, keepAlive: false},
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('@/views/mobile/news.vue'),
    meta: {title: '活动报名', tree: 1, keepAlive: false},
  },
  {
    path: '/details/:cid',
    name: 'Details',
    component: () => import('@/views/mobile/news-details.vue'),
    meta: {title: '活动详情', tree: 2, keepAlive: false},
  },
  {
    path: '/integrated',
    name: 'Integrated',
    component: () => import('@/views/integrated/index.vue'),
    meta: {title: '我要预约', tree: -3, keepAlive: false},
  },
  {
    path: '/t',
    name: 'test',
    component: () => import('@/views/integrated/t.vue'),
    meta: {title: '我要预约', tree: -3, keepAlive: false},
  },
  {
    path: '/integrated-user',
    name: 'IntegratedUser',
    component: () => import('@/views/integrated/appointment-user-info.vue'),
    meta: {title: '我要预约', tree: 3, keepAlive: false},
  },
  {
    path: '/news-window',
    name: 'NewsWindow',
    component: () => import('@/views/integrated/news-window.vue'),
    meta: {title: '活动报名', tree: 1, keepAlive: false},
  },
  {
    path: '/details-window/:cid',
    name: 'DetailsWindow',
    component: () => import('@/views/integrated/news-details-window.vue'),
    meta: {title: '活动详情', tree: 2, keepAlive: false},
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/mobile/login.vue'),
    meta: {title: '登录', tree: 2, keepAlive: false},
  },

    //测试
  {
    path: '/record-query2',
    name: 'record-query2',
    component: () => import('@/views/mobile/record-query2.vue'),
    meta: {title: '', tree: 1, keepAlive: false},
  },
  {
    path: '/record-lists2',
    name: 'record-lists2',
    component: () => import('@/views/mobile/record-lists2.vue'),
    meta: {title: '', tree: 2, keepAlive: false},
  },

];

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});


/*
* mode: 'hash' or 'history',
* */
const router = new Router({mode: 'history', routes});


router.beforeEach(async function (to, from, next) {
  /* 路由发生变化修改页面title */
  document.title = to.meta.title || process.env.VUE_APP_TITLE;


  store.dispatch('user/changeTransition', 'slide-none')
  if (from.meta.tree > to.meta.tree) {
    // 后退,想右滑动
    store.dispatch('user/changeTransition', 'slide-right')
  } else if (from.meta.tree < to.meta.tree) {
    // 前进,想左滑动
    store.dispatch('user/changeTransition', 'slide-left')
  } else {
    // 同一层级,无动画
    store.dispatch('user/changeTransition', 'slide-none')
  }


  /*
    * 1.进入页面前面判断是否为微信浏览器, 如果是,判断是否有token, 如果有token,说明已登录,放行, 否则让其登录
    * 2.没有token要求登录,跳转地址为不是登录页的地址, 否则跳转地址为login页面,  login页获取重定向地址为login页, 就会无限循环
    * 3.登录页发起微信登录授权, 用户同意,会重定向到之前的页面 , 并在浏览器地址返回code,
    * 4.在跳转的重定向地址获取code, 如果有code,就说用户已授权, 执行登录操作
    * 5.登录成功后, 把token存到store和localStore中, 放行, 跳转地址为带完整参数的,将要去的页面地址
    * */
  let isWeixin = store.state.user.isWeixin;

  //是否微信
  if(isWeixin){
    let token = store.state.user.token;
    //有token,或者是首页, 就放行,  没有token让登录
    if(token || to.path === '/home'){
      if(to.path === '/login'){ //如果已登录并且访问登录页,  跳到首页
        next('/')
      }else{
        next()
      }
    }else{
      let targetPath = to.fullPath
      if(to.path !== '/login'){ //防止无限循环跳转到登录页
        // console.log('to', to)
        let code = to.query.code

        if(code){
          await store.dispatch('user/userLogin', code)
          next(targetPath)
        }else{
          next(`/login?redirect=${targetPath}`)
        }
      }else{
        next()
      }
    }
  }else{
    next()
  }
});

export default router;
